import axios from 'axios'
import load from "@/LOAD.js";
import store from "@/store/index.js"
import storage from "./storage.js"

const instance = axios.create({
  baseURL: load.getUrlApi(),
})


// ----------------------------------
// ------------ REQUEST -------------
// ----------------------------------
instance.interceptors.request.use(config => {

  // Controllo se avviare l'attesa
  if (config.loadingBar)
    store.commit('app/SET_LOADING', true)

  // Imposto il token
  if (store.getters['auth/isAuthenticated'])
    config.headers.Authorization = storage.getAuthHeader()

  return config

}, function (error) {

  // Fine attesa
  store.commit('app/SET_LOADING', false)

  // Do something with request error
  console.log("interceptor request " + error)

  return Promise.reject(error)
})


// ----------------------------------
// ------------ RESPONSE ------------
// ----------------------------------
instance.interceptors.response.use((response) => {

  // Controllo fine attesa
  if (response.config.loadingBar)
    store.commit('app/SET_LOADING', false)

  return response

}, function (error) {
  let originalRequest = error.config

  // Controllo scadenza token
  if (error.response && error.response.status === 401 && !originalRequest._retry) {

    originalRequest._retry = true

    // RefreshToken
    return store.dispatch("auth/refreshToken").then(authResponse => {

      instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
      originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token

      return instance(originalRequest)

    })
      .catch(err => {
        console.log(error)

        // Ritorno al login
        // NOTA: se il token non è stato rinnovato dal refresh token, non posso fare la dispatch per registrare il logout,
        //       ma devo uscire per forza
        storage.logout()
      });

  }

  console.log("interceptor response " + error)

  // Fine attesa
  store.commit('app/SET_LOADING', false)

  // Msg errore
  store.commit('app/SET_MSG', error)

  return Promise.reject(error);

})

export default instance